import type { IPromptSuggestion } from "../types/promptSuggestion";

export const PROMPT_SUGGESTIONS: IPromptSuggestion[] = [
  {
    label: 'Show my portfolio summary'
  },
  {
    label: 'Chart my portfolio over 6 months'
  },
  {
    label: 'Compare my top holdings',
    prompt: 'Compare my top holdings side by side'
  },
  {
    label: "What's my diversification?"
  },
  {
    label: 'Summarize relevant news',
    prompt: 'Based on my portfolio and investments, summarize relevant news'
  },
  {
    label: 'Show investor updates'
  }
]
